import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-12 sm:py-20 px-4 bg-[#101d33]" data-id="element-105">
      <div className="max-w-2xl mx-auto" data-id="element-106">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative bg-slate-800/60 border border-green-500/20 rounded-3xl p-8 md:p-12 text-center overflow-hidden" data-id="element-107">
          {/* Background glow */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[300px] h-[300px] bg-green-500/8 rounded-full blur-[80px] pointer-events-none" data-id="element-108" />

          <div className="relative z-10 flex flex-col items-center" data-id="element-109">
            {/* Shield icon */}
            <motion.div initial={{
            scale: 0.8,
            opacity: 0
          }} whileInView={{
            scale: 1,
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="bg-green-500/15 w-20 h-20 rounded-full flex items-center justify-center border-2 border-green-500/30 mb-6" data-id="element-110">
              <ShieldCheckIcon className="w-10 h-10 text-green-400" data-id="element-111" />
            </motion.div>

            {/* Title */}
            <h2 className="text-2xl md:text-3xl font-extrabold text-white mb-6" data-id="element-112">
              Garantía total de 7 días
            </h2>

            {/* Description */}
            <p className="text-base md:text-lg text-slate-300 leading-relaxed mb-4 max-w-lg" data-id="element-113">
              Puedes probar el sistema durante una semana completa.
            </p>
            <p className="text-base md:text-lg text-slate-300 leading-relaxed mb-6 max-w-lg" data-id="element-114">
              Si dentro de los primeros 7 días sientes que el contenido no es lo
              que esperabas o no se adapta a tu forma de trabajo, simplemente
              contáctanos y te devolveremos el{' '}
              <span className="text-white font-bold" data-id="element-115">100% de tu dinero</span>.
            </p>

            {/* Highlighted closing */}
            <div className="bg-green-500/10 border border-green-500/20 rounded-xl px-6 py-4" data-id="element-116">
              <p className="text-lg md:text-xl text-green-400 font-bold" data-id="element-117">
                Sin preguntas. Sin complicaciones.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}